import React from 'react'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import TextField from '@material-ui/core/TextField'
import { controlHasError } from '../../lib/errorHandler'
import PrintText from '../../lib/PrintText'

export default function UstalenieWynikuFinansowego(props) {
  return (
    <ExpandablePanel title="ZASADY USTALENIA WYNIKU FINANSOWEGO">
      <form autoComplete="off" className="subsection">
        {props.czyPodsumowanie ? (
          <PrintText
            text={props.data.UstalenieWynikuFinansowego}
          />
        ) : (
          <TextField
            error={controlHasError(
              props.errors,
              'UstalenieWynikuFinansowego',
              props.data.UstalenieWynikuFinansowego,
            )}
            name="UstalenieWynikuFinansowego"
            label="Opis"
            multiline
            variant="outlined"
            title={props.data.UstalenieWynikuFinansowego}
            defaultValue={props.data.UstalenieWynikuFinansowego}
            onBlur={(e) =>
              props.onSetSectionData(
                'UstalenieWynikuFinansowego',
                e.target.value,
              )
            }
          />
        )}
      </form>
    </ExpandablePanel>
  )
}
